/**
 * Typed wrapper over Electron preload IPC for desktop telephony and config.
 */
export const getDesktopBridge = () => window.emmad ?? null;

export const getDesktopConfig = async () => {
  const bridge = getDesktopBridge();
  if (!bridge) {
    return null;
  }
  return bridge.getConfig();
};

export const showDesktopNotification = async (title, body) => {
  const bridge = getDesktopBridge();
  if (!bridge?.showNotification) {
    return false;
  }
  return bridge.showNotification({ title, body });
};

export const telephonyRequest = async (method, path, body) => {
  const bridge = getDesktopBridge();
  if (!bridge?.telephony) {
    throw new Error("Desktop telephony bridge is not available.");
  }
  return bridge.telephony.request(method, path, body);
};

export const subscribeTelephonyEvents = (onEvent) => {
  const bridge = getDesktopBridge();
  if (!bridge?.telephony?.subscribe) {
    return () => undefined;
  }
  return bridge.telephony.subscribe(onEvent);
};

export const focusMainWindow = async () => {
  const bridge = getDesktopBridge();
  if (bridge?.focusMainWindow) {
    await bridge.focusMainWindow();
  }
};

export const setDesktopPhonePreferences = async (prefs) => {
  const bridge = getDesktopBridge();
  if (!bridge?.setPhonePreferences) {
    return null;
  }
  return bridge.setPhonePreferences(prefs);
};

export const subscribeDesktopIncomingPopupActions = (handlers = {}) => {
  const bridge = getDesktopBridge();
  const unsubscribers = [];
  if (bridge?.onIncomingAcceptedFromPopup && handlers.onAccepted) {
    unsubscribers.push(bridge.onIncomingAcceptedFromPopup(handlers.onAccepted));
  }
  if (bridge?.onIncomingRejectedFromPopup && handlers.onRejected) {
    unsubscribers.push(bridge.onIncomingRejectedFromPopup(handlers.onRejected));
  }
  return () => {
    unsubscribers.forEach((unsub) => unsub());
  };
};
